/**
 * @file Route: cart
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import "components/Title";
import { $, $all} from "@olmokit/dom";
import { device } from "@olmokit/core/detect";
import { replaceFragments, setFragmentLoading } from "@olmokit/core/fragments";
import { cartOn, setCartQuantity } from "@olmokit/core/cart";
import StickySidebar from "@olmokit/core/scroll/stickySidebar";
import { spinners } from "@olmokit/core/forms/spinner";
import { initItems, itemOn } from "@olmokit/core/helpers/item";
import { CartContent } from "components/Cart/Content";
import { CartShipping } from "components/Cart/Shipping";
import { CartDiscount } from "components/Cart/Discount"
import "./index.scss";

console.log("Route cart/index.js mounted.");

CartDiscount();

cartOn("remove:fail", () => {
  updateCart();
});

/**
 * Riscrivere la risposta del remove in modo da passare i dati al datalayer
 */
cartOn("remove:ok", ({response}) => {
  updateCart();
});

itemOn("change", ({ data }) => {  
  setFragmentLoading("cart-content");    
  setCartQuantity(data).then( (data) => {    
    updateCart();    
  }).catch( () => {
    updateCart();
    console.log('error');
  });
});

CartContent();
function onCartItemsReady(initial?: boolean) {
  spinners();
  initItems('cart');
  floatingSummary();
  return {
    destroy() {}
  }
}

export function updateCart() {
  replaceFragments({
    "cart-content": "components.CartContent",
  }).then(() => {
    onCartItemsReady();
    CartShipping();
    CartDiscount();
  });
}

const onCartItemsReadyConst = onCartItemsReady(true);

function floatingSummary() {
  const sidebarExist = $("#CartContent-side-inner");
  const desktop = !device().any;

  if (desktop) {
    if (sidebarExist) {
      new StickySidebar("#CartContent-side-inner", {
        // containerSelector: "#product-wrap",
        innerWrapperSelector: "#CartContent-side-inner",
        topSpacing: 122,
      }); 
    }
  }
}